
























































import {Component, Vue} from "vue-property-decorator";
import dates from "@/components/inputs/dates.vue";
import Select35 from "@/components/inputs/Select35.vue";
import {ActionsEnum} from "@/entity/ActionsEnum";
import {UsersEntity} from "@/entity/UsersEntity";
import OrderTotals from "@/components/OrderTotals.vue";

export class report {
    order_count!: number;
    sub_total!: number;
    cargo_total!: number;
    kdv_total!: number;
}

class requestPayload {
    start_date: string = "";
    end_date: string = "";
    status: string = "0";
    status_condition: string = "!=";
    user_id:number | null = null
    all_dates:boolean = false;
}

@Component({
    components: {
        OrderTotals,
        Select35,
        dates
    },
})
export default class Anasayfa extends Vue {
    request: requestPayload = new requestPayload();
    data: report = new report();
    date: String = (new Date()).toISOString();
    conditions : string[] = ["=","!="];
    users : UsersEntity[] = [];
    dateChanged : boolean = false;
    async get() {
        if(this.request.start_date != "" || this.request.end_date != "")
            this.dateChanged = true;
        let response = await Vue.prototype.$http.request({
            method:"POST",
            responseType:"json",
            data:JSON.stringify(this.request),
            transformRequest:[function (data:any, headers:any) {
                return data;
            }],
            url:"report"
        });
        this.data = response.data;
    }
    async getUsers(){
        let response = await this.$http.get(ActionsEnum.UsersSanitized);
        this.users = response.data;
    }
    async created() {
        await this.$store.dispatch("getOrderStatus");
        await this.get();
        await this.getUsers();
    }

};
